import { IndicatorLabel } from "@codat/orchard-ui";
import React from "react";

export const StateIndicatorLabel: React.FC<{ state: string }> = ({ state }) => {
  switch (state) {
    case "Success":
      return <IndicatorLabel label={state} color="positive" />;
    case "Unknown":
    case "Pending":
      return <IndicatorLabel label={state} color="neutral" />;
    case "Failure":
    case "Failed":
    case "TimeOut":
      return <IndicatorLabel label={state} color="negative" />;
    default:
      return <IndicatorLabel label={state} />;
  }
};
